import {v4 as uuidv4} from 'uuid';

type StringGeneratorFunc = () => string;
let generator: StringGeneratorFunc = uuidv4;

export const setGenerateIdFunc = (func: StringGeneratorFunc) => {
    generator = func;
};

export const generateId = () => {
    const uuid = generator();

    const hex = uuid.replace(/-/g, '');

    const cleaned =
        hex.slice(0, 12) +
        hex.slice(13, 16) +
        hex.slice(17);

    return cleaned.slice(0, 26);
}
